import {defineStore} from 'pinia'
export const useUserStore = defineStore('user',{
   
    state:()=>{
        return {
            authToken:'',
        }
    },
    actions:{
        setAuthToken(token){
              this.authToken = token;
        },

    } 
})